<template>
  <div id="filters" class="vertical-align" style="height: 100%">
    <template v-if="type === 'author'">
      <template v-if="workflowId === 1 || workflowId === 2 || workflowId === 3">
        <div class="col-xs-12 col-md-3 text-right filter" v-if="$user.isSe() || $user.isBicWorld()" :style="cssProps">
          <div class="dropdown">
            <button class="btn btn-xs" :class="{'btn-default': context.expertSourceSelected.length === 0, 'btn-info' : context.expertSourceSelected.length !== 0, custom: $user.isSe() || $user.isBicWorld()}" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Expert Type
              <span class="caret"></span>
            </button>
            <div class="dropdown-menu pull-right" aria-labelledby="dLabel3">
              <expert-source-box :expertSources="context.expertSourceFilter" :expertSourcesSelected="context.expertSourceSelected"/>
            </div>
          </div>
        </div>
        <template v-else>
          <div class="col-xs-3"></div>
        </template>
        <div class="col-xs-12 col-md-3 text-right filter" v-if="context.affiliationsSelected">
          <div class="dropdown">
            <button class="btn btn-xs" :class="context.affiliationsSelected.length === 0 ? 'btn-default':'btn-info'" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Organisation
              <span class="caret"></span>
            </button>
            <div class="dropdown-menu pull-right" aria-labelledby="dLabel">
              <organisation-box :affiliations="context.affiliationsFilter" :affiliationsSelected="context.affiliationsSelected"/>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-3 text-right filter" v-if="context.countriesSelected">
          <div class="dropdown">
            <button class="btn btn-xs" :class="context.countriesSelected.length === 0 ? 'btn-default':'btn-info'" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Country
              <span class="caret"></span>
            </button>
            <div class="dropdown-menu pull-right" aria-labelledby="dLabel2">
              <country-box :countries="context.countriesFilter" :countriesSelected="context.countriesSelected"/>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-3 text-right filter" v-if="context.pubDateSelected">
          <div class="dropdown">
            <button class="btn btn-xs" :class="context.pubDateSelected.length === 0 ? 'btn-default':'btn-info'" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Year
              <span class="caret"></span>
            </button>
            <div class="dropdown-menu pull-right" aria-labelledby="dLabel3">
              <year-box :years="context.pubDateFilter" :yearsSelected="context.pubDateSelected"/>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-3 text-right filter" v-if="isFollowedSearch">
          <div class="dropdown">
            <button class="btn btn-xs" :class="context.newDocumentsSelected.length === 0 ? 'btn-default':'btn-info'" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              New docs
              <span class="caret"></span>
            </button>
            <div class="dropdown-menu pull-right" aria-labelledby="dLabel3">
              <new-documents-box :newDocuments="context.newDocumentsFilter" :newDocumentsSelected="context.newDocumentsSelected"/>
            </div>
          </div>
        </div>
      </template>

    </template>
    <template v-else-if="type === 'patents'">
      <template v-if="workflowId === 1 || workflowId === 2 || workflowId === 3">
        <div class="col-xs-12 col-md-4 text-right filter">
          <div class="dropdown">
            <button class="btn btn-xs" :class="context.affiliationsSelected.length === 0 ? 'btn-default':'btn-info'" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Organisation
              <span class="caret"></span>
            </button>
            <div class="dropdown-menu pull-right" aria-labelledby="dLabel">
              <organisation-box :affiliations="context.affiliationsFilter" :affiliationsSelected="context.affiliationsSelected"/>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-4 text-right filter">
          <div class="dropdown">
            <button class="btn btn-xs" :class="context.countriesSelected.length === 0 ? 'btn-default':'btn-info'" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Country
              <span class="caret"></span>
            </button>
            <div class="dropdown-menu pull-right" aria-labelledby="dLabel2">
              <country-box :countries="context.countriesFilter" :countriesSelected="context.countriesSelected"/>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-4 text-right filter">
          <div class="dropdown">
            <button class="btn btn-xs" :class="context.pubDateSelected.length === 0 ? 'btn-default':'btn-info'" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Year
              <span class="caret"></span>
            </button>
            <div class="dropdown-menu pull-right" aria-labelledby="dLabel3">
              <year-box :years="context.pubDateFilter" :yearsSelected="context.pubDateSelected"/>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-3 text-right filter" v-if="isFollowedSearch">
          <div class="dropdown">
            <button class="btn btn-xs" :class="context.newDocumentsSelected.length === 0 ? 'btn-default':'btn-info'" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              New docs
              <span class="caret"></span>
            </button>
            <div class="dropdown-menu pull-right" aria-labelledby="dLabel3">
              <new-documents-box :newDocuments="context.newDocumentsFilter" :newDocumentsSelected="context.newDocumentsSelected"/>
            </div>
          </div>
        </div>
      </template>

    </template>
    <template v-else-if="type === 'company'">
      <div class="col-md-offset-2"></div>
      <div class="col-xs-2 col-md-2 text-right filter" v-if="context.countriesSelected">
        <div class="dropdown text">
          <button class="btn btn-xs" :class="context.countriesSelected.length === 0 ? 'btn-default':'btn-info'" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Country
            <span class="caret"></span>
          </button>
          <div class="dropdown-menu pull-right" aria-labelledby="dLabel2">
            <country-box :countries="context.countriesFilter" :countriesSelected="context.countriesSelected"/>
          </div>
        </div>
      </div>
      <div class="col-xs-3 col-md-2 text-right filter" v-if="context.dateIncorporateSelected">
        <div class="dropdown">
          <button class="btn btn-xs" :class="context.dateIncorporateSelected.length === 0 ? 'btn-default':'btn-info'" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span class="hidden-sm hidden-md hidden-xs">Incorp. Date</span>
            <span class="hidden-lg">Date</span>
            <span class="caret"></span>
          </button>
          <div class="dropdown-menu pull-right" aria-labelledby="dLabel3">
            <DateIncorporated :years="context.dateIncorporateFilter" :yearsSelected="context.dateIncorporateSelected"/>
          </div>
        </div>
      </div>
      <div class="col-xs-2 col-md-2 text-right filter" v-if="context.categorySelected">
        <div class="dropdown">
          <button class="btn btn-xs" :class="context.categorySelected.length === 0 ? 'btn-default':'btn-info'" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span class="hidden-sm hidden-md hidden-xs">Category</span>
            <span class="hidden-lg">Cat</span>
            <span class="caret"></span>
          </button>
          <div class="dropdown-menu pull-right" aria-labelledby="dLabel3">
            <CategoryBox :categories="context.categoryFilter" :categoriesSelected="context.categorySelected"/>
          </div>
        </div>
      </div>
      <div class="col-xs-2 col-md-2 text-right filter" v-if="context.affiliationTypeSelected">
        <div class="dropdown">
          <button class="btn btn-xs" :class="context.affiliationTypeSelected.length === 0 ? 'btn-default':'btn-info'" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span class="hidden-sm hidden-md hidden-xs">Affiliation Type</span>
            <span class="hidden-lg">Aff Type</span>
            <span class="caret"></span>
          </button>
          <div class="dropdown-menu pull-right" aria-labelledby="dLabel3">
            <AffiliationTypeBox :affiliationsType="context.affiliationTypeFilter" :affiliationsTypeSelected="context.affiliationTypeSelected"/>
          </div>
        </div>
      </div>

    </template>
    <template v-else-if="type === 'news'">
      <div class="col-md-offset-2"></div>
      <div class="col-xs-4 col-md-4 text-right filter" v-if="context.newsProviderSelected">
        <div class="dropdown">
          <button class="btn btn-xs" :class="context.newsProviderSelected.length === 0 ? 'btn-default':'btn-info'" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span class="hidden-sm hidden-md hidden-xs">Provider</span>
            <span class="hidden-lg">Prov</span>
            <span class="caret"></span>
          </button>
          <div class="dropdown-menu pull-right" aria-labelledby="dLabel3">
            <CategoryBox :categories="context.newsProviderFilter" :categoriesSelected="context.newsProviderSelected"/>
          </div>
        </div>
      </div>
      <div class="col-xs-4 col-md-4 text-right filter" v-if="context.newsDateSelected">
        <div class="dropdown">
          <button class="btn btn-xs" :class="context.newsDateSelected.length === 0 ? 'btn-default':'btn-info'" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span class="hidden-sm hidden-md hidden-xs">Publication Date</span>
            <span class="hidden-lg">Date</span>
            <span class="caret"></span>
          </button>
          <div class="dropdown-menu pull-right" aria-labelledby="dLabel3">
            <DateIncorporated :years="context.newsDateFilter" :yearsSelected="context.newsDateSelected"/>
          </div>
        </div>
      </div>
    </template>

  </div>
</template>

<style scoped>

  .btn-default.custom{
    color: var(--color);
  }

  .btn-info.custom{
    color: #fff;
    background-color: var(--color);
    border-color: var(--color);
  }
  .btn-info:hover.custom,
  .btn-info:focus.custom,
  .btn-info.focus.custom,
  .btn-info:active.custom,
  .btn-info.active.custom,
  .open > .dropdown-toggle.btn-info.custom{
    color: #fff;
    background-color: var(--color);
    border-color: var(--color);
  }

</style>
<script>
import VueLadda from 'vue-ladda'
import YearBox from '../filter/YearBox'
import PublicationBox from '../filter/PublicationBox'
import OrganisationBox from '../filter/OrganisationBox'
import CountryBox from '../filter/CountryBox'
import ExpertSourceBox from '../filter/ExpertSourceBox'
import DateIncorporated from '../filter/DateIncorporated'
import CategoryBox from '../filter/CategoryBox'
import AffiliationTypeBox from '../filter/AffiliationTypeBox'
import NewDocumentsBox from './NewDocumentsBox'

export default {
  components: {
    NewDocumentsBox,
    AffiliationTypeBox,
    CategoryBox,
    DateIncorporated,
    ExpertSourceBox,
    CountryBox,
    OrganisationBox,
    PublicationBox,
    YearBox,
    VueLadda
  },
  props: {'type': {}, 'workflowId': {}, 'context': {}, 'isFollowedSearch': {default: false}},
  name: 'Filters',
  computed: {
    cssProps () {
      return {
        '--color': '#' + this.$auth.user().profile.color_expert
      }
    }
  },
  watch: {
    'context.affiliationTypeFilter': function (val, oldVal) {
      if (this.context.name === 'expertResult') {
        if (typeof val !== 'undefined' && val.length !== 0 && oldVal.length === 0) {
          let affiliationType = val.find((affiliationType) => affiliationType.name === false)

          if (typeof affiliationType !== 'undefined') {
            this.context.affiliationTypeSelected.push(affiliationType)
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/filter/Filters.vue